import { render, staticRenderFns } from "./modalDadosCadastrais.vue?vue&type=template&id=6feca7a0"
import script from "./modalDadosCadastrais.vue?vue&type=script&lang=js"
export * from "./modalDadosCadastrais.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports